// extracted by mini-css-extract-plugin
export default {"inner_canvas":"PageCampaignSetup_inner_canvas__FGUjy"};